export default __webpack_public_path__ + "static/media/Linked_List_Deletion_2.41eca75b.gif";